export default function Dashboard() {
  return (
    <section className="sales-layout__page">
      <h1>Dashboard</h1>
      <p>Das Sales-Modul ist freigeschaltet. Die Funktionen sind in Vorbereitung.</p>
    </section>
  );
}
